import * as Dtos from '../../dtos/Tmd.dtos';
import { IFieldState, IRegistrationFormState } from "./index";

export const initialTrialInstitutionLaboratoryState: Dtos.TrialInstitutionLaboratory & IRegistrationFormState = {
    id: null,
    laboratoryId: null,
    laboratory: null,
    trialInstitutionId: null,
    trialInstitution: null,
    dateCeased: null,
    active: null,
    dateEntered: null,
    dateModified: null,
    enteredBy: null,
    modifiedBy: null,
    saveAndReturn: false,
    personnels: []
}

export interface ITrialInstitutionLaboratoryReduxFormState {
    id: IFieldState<number>,
    laboratoryId: IFieldState<number>,
    trialInstitutionId:IFieldState<number>,
    dateCeased: IFieldState<string>,
    active: IFieldState<boolean>,
    dateEntered: IFieldState<string>,
    dateModified: IFieldState<string>,
    enteredBy: IFieldState<string>,
    modifiedBy: IFieldState<string>,
    saveAndReturn: IFieldState<boolean>
}